// Routes any stored media reference through the same-origin /api/media
// proxy. The DB stores canonical S3 URLs (or, historically, a few other
// bases); rendering them directly fails when the bucket blocks public GET.
// The proxy streams from S3 with server credentials, so it always loads.
//
// Handles every shape we might have stored:
//   - full S3 URL        → extract the avatars/… or group-logos/… key
//   - already-proxied    → pass through
//   - data: URI / blob:  → pass through (never proxy)
//   - unknown external   → pass through unchanged
export function mediaUrl(stored?: string | null): string | undefined {
  if (!stored) return undefined;
  if (stored.startsWith("/api/media/") || stored.startsWith("data:") || stored.startsWith("blob:")) {
    return stored;
  }
  // Pull our S3 key out of whatever base the URL uses — the key always
  // begins with one of the two known prefixes.
  const m = stored.match(/(avatars|group-logos)\/[A-Za-z0-9._\-/]+/);
  if (m) return `/api/media/${m[0]}`;
  return stored;
}
